import { ApiOptions, UserI } from "@Interfaces";
import { CategoryHierarchy, ICategory } from "@Interfaces/Api/category";
import {
  IAddress,
  IForgot,
  ILoginType,
  IMeResponse,
  IRegister,
  IResetPassword,
  IUser,
  IVerify,
} from "@Interfaces/Api/user";
import { ApiCore } from "@Services/API/Core";
import { apiProvider } from "@Services/API/Provider";

// const url = "user/login/password";

// export const Login = new ApiCore<any>({
//   getAll: false,
//   getSingle: false,
//   post: true,
//   put: false,
//   patch: false,
//   remove: false,
//   url: "user/login/password",
// });

// export const Register = new ApiCore<any>({
//   getAll: false,
//   getSingle: false,
//   post: true,
//   put: false,
//   patch: false,
//   remove: false,
//   url: "user/signup",
// });

// export const verify = new ApiCore<any>({
//   getAll: false,
//   getSingle: false,
//   post: true,
//   put: false,
//   patch: false,
//   remove: false,
//   url: "user/verify",
// });

// export const LoginWithOtp = new ApiCore<any>({
//   getAll: false,
//   getSingle: false,
//   post: true,
//   put: false,
//   patch: false,
//   remove: false,
//   url: "user/login/sendOtp",
// });
// export const Forgot = new ApiCore<any>({
//   getAll: false,
//   getSingle: false,
//   post: true,
//   put: false,
//   patch: false,
//   remove: false,
//   url: "user/forgot",
// });
// export const ResetPassword = new ApiCore<any>({
//   getAll: false,
//   getSingle: false,
//   post: true,
//   put: false,
//   patch: false,
//   remove: false,
//   url: "user/resetPassword",
// });
// export const LogOut = new ApiCore<any>({
//   getAll: false,
//   getSingle: false,
//   post: true,
//   put: false,
//   patch: false,
//   remove: false,
//   url: "user/logout",
// });

export const me = new ApiCore<any>({
  getAll: false,
  getSingle: true,
  post: false,
  put: false,
  patch: false,
  remove: false,
  url: "user/me",
});

class UserAPICore extends ApiCore<IUser> {
  getMYDetails: () => Promise<IMeResponse>;
  updateUserProfile: (modal: IMeResponse) => Promise<IMeResponse>;
  login: (modal: ILoginType) => Promise<ILoginType>;
  register: (modal: IRegister) => Promise<IRegister>;
  verify: (modal: IVerify, queryParam: string) => Promise<IVerify>;
  forgot: (modal: IForgot) => Promise<IForgot>;
  resetPassword: (modal: IResetPassword) => Promise<IResetPassword>;
  loginWithOtp: (modal: IVerify) => Promise<IVerify>;
  logout: (modal: Object) => Promise<Object>;

  constructor(options: ApiOptions) {
    super(options);
    this.getMYDetails = () => {
      return apiProvider.getAll(`${options.url}/me`);
    };
    this.updateUserProfile = (modal: IMeResponse) => {
      return apiProvider.post(`${options.url}/updateUserProfile`, modal);
    };
    this.login = (modal: ILoginType) => {
      return apiProvider.post(`${options.url}/login/password`, modal);
    };
    this.register = (modal: IRegister) => {
      return apiProvider.post(`${options.url}/signup`, modal);
    };
    this.verify = (modal: IVerify, queryParam: string) => {
      return apiProvider.post(`${options.url}/verify`, modal, queryParam);
    };
    this.forgot = (modal: IForgot) => {
      return apiProvider.post(`${options.url}/forgot`, modal);
    };
    this.loginWithOtp = (modal: IVerify) => {
      return apiProvider.post(`${options.url}/login/sendOtp`, modal);
    };
    this.resetPassword = (modal: IResetPassword) => {
      return apiProvider.post(`${options.url}/resetPassword`, modal);
    };

    this.logout = (modal: object) => {
      return apiProvider.post(`${options.url}/logout`, modal);
    };
    this.checkUserExists = (modal: object) => {
      return apiProvider.post(`${options.url}/checkuserExistance`, modal);
    };
  }
}

export const apiUser = new UserAPICore({
  getAll: false,
  getSingle: true,
  post: false,
  put: false,
  patch: false,
  remove: false,
  url: "user",
});
